// all props have to be defined in here or the "Start Over" button doesn't work
const sale = (config, args) => ({
  id: null,
  promoCode: null,
  day: null,
  packages: {},
  reservedPackages: {},
  expiredPackages: false,
  packageAddOns: {},
  packageAddOnGuests: {},
  deals: {},
  benefits: [],
  ...args
});

export default sale;
